// SparkX AI License Config — AlifKart
// এই ফাইলটি সরাসরি .gitignore তে যোগ করুন, public repo তে commit করবেন না।

export const LICENSE_CONFIG = {
  apiUrl: 'https://guard-server.sparkx-ai.shop/api/v1/verify-license',
  renewalApiUrl: 'https://guard-server.sparkx-ai.shop/api/v1/request-renewal-payment',
  packageStatusApiUrl: 'https://guard-server.sparkx-ai.shop/api/v1/package-status',
  requestPackagePaymentApiUrl: 'https://guard-server.sparkx-ai.shop/api/v1/request-package-payment',
  packagesApiUrl: 'https://guard-server.sparkx-ai.shop/api/v1/packages',
  requestPackageUpgradeApiUrl: 'https://guard-server.sparkx-ai.shop/api/v1/request-package-upgrade',
  apiKey: 'lic_live_dfc71e01a7dc703492c945ab4137f1d63da4af4f1150495c',
  domain: 'nilachol-cafe-restaurant-admin-panel.pages.dev',
  supportWhatsApp: '01516585709',
};